
import { TelematicsConnectionDeletedDto_$reflection, TelematicsConnectionDto_$reflection, SaveTelematicsConnectionDto_$reflection, TelematicsVerificationDto_$reflection, TelematicsConnectionOverviewDto, TelematicsConnectionOverviewDto_$reflection, SaveTelematicsConnectionDto, TelematicsProvider } from "../../../Shared/Telematics.js";
import { map, orElse, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ofArray, singleton, head, tryHead } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { WizardStepModule_back, WizardStepModule_next, Msg, State, Wizard as Wizard_4, Verification as Verification_5, WizardStepModule_forMode } from "./Types.js";
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";

function saveDto(wizard) {
    return new SaveTelematicsConnectionDto(new TelematicsProvider(), (wizard.ApiKey.trim() === "") ? undefined : wizard.ApiKey.trim());
}

const storedKeyDto = new SaveTelematicsConnectionDto(new TelematicsProvider(), undefined);

function failureMessage(validation) {
    return defaultArg(orElse(validation.GlobalValidationMessage, map((validation_1) => validation_1.ErrorMessage, tryHead(validation.Validations))), "telematics.error.provider_unavailable");
}

function newWizard(mode) {
    return new Wizard_4(mode, head(WizardStepModule_forMode(mode)), "", false, new Verification_5(0, []));
}

export function init() {
    return [new State(new RequestedValue$1(0, []), false, undefined, new Verification_5(0, []), false, FormState_get_empty()), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), TelematicsConnectionOverviewDto_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/telematics/connection", (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(18, [Item_1])))];
}

function updateWizard(state, change) {
    return new State(state.Overview, state.LoadFailed, map(change, state.Wizard), state.StoredKeyTest, state.IsDisconnectDialogOpen, state.FormState);
}

function withConnection(state, connection) {
    const matchValue = state.Overview;
    if (matchValue.tag === 0) {
        return new RequestedValue$1(0, []);
    }
    else {
        return new RequestedValue$1(1, [new TelematicsConnectionOverviewDto(matchValue.fields[0].ProviderHost, connection)]);
    }
}

export function update(msg, state) {
    let bind$0040, dto, bind$0040_2, bind$0040_1, dto_1, FormState_13, StoredKeyTest_3, matchValue_5;
    const matchValue = state.Wizard;
    let matchResult, overview, mode, wizard, wizard_2, apiKey, wizard_6, response_4, wizard_10, response_7, response_10, response_15;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            mode = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 3;
            break;
        }
        case 4: {
            if (matchValue == null) {
                matchResult = 19;
            }
            else {
                matchResult = 4;
                wizard = matchValue;
            }
            break;
        }
        case 5: {
            if (matchValue == null) {
                matchResult = 19;
            }
            else {
                matchResult = 5;
                wizard_2 = matchValue;
            }
            break;
        }
        case 6: {
            if (matchValue == null) {
                matchResult = 19;
            }
            else {
                matchResult = 6;
                apiKey = msg.fields[0];
            }
            break;
        }
        case 7: {
            if (matchValue == null) {
                matchResult = 19;
            }
            else {
                matchResult = 7;
            }
            break;
        }
        case 8: {
            if (matchValue == null) {
                matchResult = 19;
            }
            else {
                matchResult = 8;
                wizard_6 = matchValue;
            }
            break;
        }
        case 9: {
            if (matchValue == null) {
                matchResult = 19;
            }
            else {
                matchResult = 9;
                response_4 = msg.fields[0];
            }
            break;
        }
        case 10: {
            if (matchValue == null) {
                matchResult = 19;
            }
            else {
                matchResult = 10;
                wizard_10 = matchValue;
            }
            break;
        }
        case 11: {
            matchResult = 11;
            response_7 = msg.fields[0];
            break;
        }
        case 12: {
            matchResult = 12;
            break;
        }
        case 13: {
            matchResult = 13;
            response_10 = msg.fields[0];
            break;
        }
        case 14: {
            matchResult = 14;
            break;
        }
        case 15: {
            matchResult = 15;
            break;
        }
        case 16: {
            matchResult = 16;
            break;
        }
        case 17: {
            matchResult = 17;
            response_15 = msg.fields[0];
            break;
        }
        case 18: {
            matchResult = 18;
            break;
        }
        default: {
            matchResult = 0;
            overview = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return [new State(new RequestedValue$1(1, [overview]), false, state.Wizard, state.StoredKeyTest, state.IsDisconnectDialogOpen, state.FormState), Cmd_none()];
        case 1:
            return [new State(state.Overview, false, state.Wizard, state.StoredKeyTest, state.IsDisconnectDialogOpen, state.FormState), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), TelematicsConnectionOverviewDto_$reflection()));
                }, refreshOn)))(true).then((_arg) => {
                    const result_1 = _arg;
                    return (result_1.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_1.fields[0]);
                    })())) : (Promise.resolve(result_1.fields[0]));
                });
            })), "/api/telematics/connection", (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(18, [Item_1])))];
        case 2:
            return [new State(state.Overview, state.LoadFailed, newWizard(mode), state.StoredKeyTest, state.IsDisconnectDialogOpen, FormState_get_empty()), Cmd_none()];
        case 3:
            return [new State(state.Overview, state.LoadFailed, undefined, state.StoredKeyTest, state.IsDisconnectDialogOpen, FormState_get_empty()), Cmd_none()];
        case 4: {
            const matchValue_2 = WizardStepModule_next(wizard.Mode, wizard.Step);
            if (matchValue_2 == null) {
                return [state, Cmd_none()];
            }
            else {
                const step = matchValue_2;
                return [updateWizard(state, (wizard_1) => (new Wizard_4(wizard_1.Mode, step, wizard_1.ApiKey, wizard_1.ApiKeyVisible, wizard_1.Verification))), Cmd_none()];
            }
        }
        case 5: {
            const matchValue_3 = WizardStepModule_back(wizard_2.Mode, wizard_2.Step);
            if (matchValue_3 == null) {
                return [state, Cmd_none()];
            }
            else {
                const step_1 = matchValue_3;
                return [updateWizard(state, (wizard_3) => (new Wizard_4(wizard_3.Mode, step_1, wizard_3.ApiKey, wizard_3.ApiKeyVisible, wizard_3.Verification))), Cmd_none()];
            }
        }
        case 6:
            return [updateWizard(state, (wizard_4) => (new Wizard_4(wizard_4.Mode, wizard_4.Step, apiKey, wizard_4.ApiKeyVisible, new Verification_5(0, [])))), Cmd_none()];
        case 7:
            return [updateWizard(state, (wizard_5) => (new Wizard_4(wizard_5.Mode, wizard_5.Step, wizard_5.ApiKey, !wizard_5.ApiKeyVisible, wizard_5.Verification))), Cmd_none()];
        case 8:
            return [(bind$0040 = updateWizard(state, (wizard_7) => (new Wizard_4(wizard_7.Mode, wizard_7.Step, wizard_7.ApiKey, wizard_7.ApiKeyVisible, new Verification_5(1, [])))), new State(bind$0040.Overview, bind$0040.LoadFailed, bind$0040.Wizard, bind$0040.StoredKeyTest, bind$0040.IsDisconnectDialogOpen, FormState__startLoading(state.FormState))), (dto = saveDto(wizard_6), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_5;
                return ((url_5 = addPrefix(tupledArg[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_2) => {
                    const pr_1 = response_2.arrayBuffer();
                    return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), TelematicsVerificationDto_$reflection()));
                }, refreshOn_1)))(true);
            })), ["/api/telematics/connection/verify", toString(0, Auto_generateBoxedEncoder_437914C6(SaveTelematicsConnectionDto_$reflection(), undefined, undefined, undefined)(dto))], (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(18, [Item_3]))))];
        case 9:
            if (response_4.tag === 1) {
                return [(bind$0040_2 = updateWizard(state, (wizard_9) => (new Wizard_4(wizard_9.Mode, wizard_9.Step, wizard_9.ApiKey, wizard_9.ApiKeyVisible, new Verification_5(3, [failureMessage(response_4.fields[0])])))), new State(bind$0040_2.Overview, bind$0040_2.LoadFailed, bind$0040_2.Wizard, bind$0040_2.StoredKeyTest, bind$0040_2.IsDisconnectDialogOpen, FormState_get_empty())), Cmd_none()];
            }
            else {
                return [(bind$0040_1 = updateWizard(state, (wizard_8) => (new Wizard_4(wizard_8.Mode, wizard_8.Step, wizard_8.ApiKey, wizard_8.ApiKeyVisible, new Verification_5(2, [response_4.fields[0]])))), new State(bind$0040_1.Overview, bind$0040_1.LoadFailed, bind$0040_1.Wizard, bind$0040_1.StoredKeyTest, bind$0040_1.IsDisconnectDialogOpen, FormState_get_empty())), Cmd_none()];
            }
        case 10:
            return [new State(state.Overview, state.LoadFailed, state.Wizard, state.StoredKeyTest, state.IsDisconnectDialogOpen, FormState__startLoading(state.FormState)), (dto_1 = saveDto(wizard_10), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_8;
                return ((url_8 = addPrefix(tupledArg_1[0]), (refreshOn_2) => fetchWithDecoder(url_8, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_5) => {
                    const pr_2 = response_5.arrayBuffer();
                    return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), TelematicsConnectionDto_$reflection()));
                }, refreshOn_2)))(true);
            })), ["/api/telematics/connection", toString(0, Auto_generateBoxedEncoder_437914C6(SaveTelematicsConnectionDto_$reflection(), undefined, undefined, undefined)(dto_1))], (Item_4) => (new Msg(11, [Item_4])), (Item_5) => (new Msg(18, [Item_5]))))];
        case 11:
            if (response_7.tag === 1) {
                return [new State(state.Overview, state.LoadFailed, state.Wizard, state.StoredKeyTest, state.IsDisconnectDialogOpen, FormState__setValidationResponse_5219762A(state.FormState, response_7.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(withConnection(state, response_7.fields[0]), state.LoadFailed, undefined, new Verification_5(0, []), state.IsDisconnectDialogOpen, FormState_get_empty()), Cmd_successToast("settings.telematics.saved")];
            }
        case 12:
            return [new State(state.Overview, state.LoadFailed, state.Wizard, new Verification_5(1, []), state.IsDisconnectDialogOpen, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((tupledArg_2) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_11;
                return ((url_11 = addPrefix(tupledArg_2[0]), (refreshOn_3) => fetchWithDecoder(url_11, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg_2[1]])]), "application/json", (response_8) => {
                    const pr_3 = response_8.arrayBuffer();
                    return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), TelematicsVerificationDto_$reflection()));
                }, refreshOn_3)))(true);
            })), ["/api/telematics/connection/verify", toString(0, Auto_generateBoxedEncoder_437914C6(SaveTelematicsConnectionDto_$reflection(), undefined, undefined, undefined)(storedKeyDto))], (Item_6) => (new Msg(13, [Item_6])), (Item_7) => (new Msg(18, [Item_7])))];
        case 13:
            return [new State(state.Overview, state.LoadFailed, state.Wizard, (response_10.tag === 1) ? (new Verification_5(3, [failureMessage(response_10.fields[0])])) : (new Verification_5(2, [response_10.fields[0]])), state.IsDisconnectDialogOpen, FormState_get_empty()), Cmd_OfPromise_either((url_12) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_14;
                return ((url_14 = addPrefix(url_12), (refreshOn_4) => fetchWithDecoder(url_14, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_11) => {
                    const pr_4 = response_11.arrayBuffer();
                    return pr_4.then((blob_4) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_4)), TelematicsConnectionOverviewDto_$reflection()));
                }, refreshOn_4)))(true).then((_arg_1) => {
                    const result_6 = _arg_1;
                    return (result_6.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_6.fields[0]);
                    })())) : (Promise.resolve(result_6.fields[0]));
                });
            })), "/api/telematics/connection", (Item_8) => (new Msg(0, [Item_8])), (Item_9) => (new Msg(18, [Item_9])))];
        case 14:
            return [new State(state.Overview, state.LoadFailed, state.Wizard, state.StoredKeyTest, true, state.FormState), Cmd_none()];
        case 15:
            return [new State(state.Overview, state.LoadFailed, state.Wizard, state.StoredKeyTest, false, state.FormState), Cmd_none()];
        case 16:
            return [new State(state.Overview, state.LoadFailed, state.Wizard, state.StoredKeyTest, state.IsDisconnectDialogOpen, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((url_15) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_17;
                return ((url_17 = addPrefix(url_15), (refreshOn_5) => fetchWithDecoder(url_17, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response_13) => {
                    const pr_5 = response_13.arrayBuffer();
                    return pr_5.then((blob_5) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_5)), TelematicsConnectionDeletedDto_$reflection()));
                }, refreshOn_5)))(true);
            })), "/api/telematics/connection", (Item_10) => (new Msg(17, [Item_10])), (Item_11) => (new Msg(18, [Item_11])))];
        case 17:
            if (response_15.tag === 1) {
                return [new State(state.Overview, state.LoadFailed, state.Wizard, state.StoredKeyTest, false, FormState__setValidationResponse_5219762A(state.FormState, response_15.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(withConnection(state, undefined), state.LoadFailed, state.Wizard, new Verification_5(0, []), false, FormState_get_empty()), Cmd_successToast("settings.telematics.disconnected")];
            }
        case 18:
            return [(FormState_13 = FormState_get_empty(), (StoredKeyTest_3 = ((matchValue_5 = state.StoredKeyTest, (matchValue_5.tag === 1) ? (new Verification_5(3, ["telematics.error.provider_unavailable"])) : matchValue_5)), new State(state.Overview, (state.Overview.tag === 1) ? state.LoadFailed : true, map((wizard_11) => {
                if (wizard_11.Verification.tag === 1) {
                    return new Wizard_4(wizard_11.Mode, wizard_11.Step, wizard_11.ApiKey, wizard_11.ApiKeyVisible, new Verification_5(3, ["telematics.error.provider_unavailable"]));
                }
                else {
                    return wizard_11;
                }
            }, state.Wizard), StoredKeyTest_3, state.IsDisconnectDialogOpen, FormState_13))), Cmd_errorToast("general.error")];
        default:
            return [state, Cmd_none()];
    }
}

